// Generated by CoffeeScript 2.7.0
var DEFAULT_PUSHPACKAGE, EditPushPackageModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import FieldList from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

import PayloadItem from 'trunks/vue/admin/compositions/push_package/push_package_modal/payload_item.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

DEFAULT_PUSHPACKAGE = {
  name: '未命名推送包',
  payload: [
    {
      push_type: "Push::CustomMessage",
      waiting: 0
    }
  ]
};

export default EditPushPackageModal = Vue.extend({
  components: {
    'modal': Modal,
    'field-list': FieldList,
    PayloadItem: PayloadItem
  },
  props: {
    title: {
      type: String
    },
    callback: {
      type: Function
    },
    initialPushPackage: {
      type: Object
    }
  },
  data: function() {
    var ref;
    return {
      pushPackage: this._generatePushPackage(),
      pushPackageName: ((ref = this.initialPushPackage) != null ? ref.name : void 0) || '未命名推送包',
      valid: true
    };
  },
  template: `<modal :title="title"
       extendClass="push-package-modal"
       @ensureClicked="ensureClickedFunc"
       @cancelClicked="cancelClickedFunc"
       size='small'
       ref="pushPackageModalRef">
  <template>
    <div class="modal-body mt-5" >
      <div class="form-field required"
           :class="{ 'has-error': !valid }">
        <div class="form-field-head mr-2">
          <div class="form-field-title">推送包名称</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input class="form-field-value"
                   placeholder="请输入推送包名称"
                   type="text"
                   v-model.trim="pushPackageName"
                   @focus='focusFunc' >
          </div>
          <div class="message">不能为空</div>
        </div>
      </div>
      <div class="form-field required"
           :class="{ 'has-error': !valid }">
        <div class="form-field-head mr-2">
          <div class="form-field-title">推送任务</div>
        </div>
        <div class="form-field-input-container mt-3">
          <PayloadItem v-for="(payload, index) in pushPackage.payload"
                       :key="index"
                       :initialPayload='payload'
                       :index='index'
                       @payloadChanged='payloadChangedFunc'
                       @deletedPayload='deletedPayloadFunc'
                       ref="payloadRef" />
          <div class="form-field-group add-push-btn inline mb-4">
            <button class="text-btn btn-primary"
                    @click="addPayloadFunc">
              <i class="slp-plus-circle"></i>
              <span>新增推送任务</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
</modal>`,
  methods: {
    ensureClickedFunc: function() {
      this._validate();
      if (!this.valid) {
        this.$refs.pushPackageModalRef.open();
        return;
      }
      this.pushPackage.name = this.pushPackageName;
      return this.callback(this.pushPackage);
    },
    cancelClickedFunc: function() {
      return this.pushPackage = this._generatePushPackage();
    },
    payloadChangedFunc: function(index, payload) {
      return this.pushPackage.payload[index] = payload;
    },
    focusFunc: function(event) {
      return event.target.select();
    },
    addPayloadFunc: function() {
      return this.pushPackage.payload.push({
        push_type: "Push::CustomMessage",
        waiting: 0
      });
    },
    deletedPayloadFunc: function(index, payload) {
      if (this.pushPackage.payload.length > 1) {
        return this.pushPackage.payload.splice(index, 1);
      } else {
        return Skylark.Bridge.newAlertify('最后一个推送任务不能删除，请删除推送包', {
          type: 'error'
        });
      }
    },
    _generatePushPackage: function() {
      if (this.initialPushPackage) {
        return JSON.parse(JSON.stringify(this.initialPushPackage));
      } else {
        return JSON.parse(JSON.stringify(DEFAULT_PUSHPACKAGE));
      }
    },
    _validate: function() {
      return this.valid = Boolean(this.pushPackageName);
    }
  }
});
